export function Input(props) {
  return (
    <input
      className="border border-gray-500 rounded-md p-1 text-sm font-thin"
      {...props}
    />
  );
}
